import React, { useEffect, useState } from "react";
import { Table, Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { MdWarningAmber, MdFullscreenExit } from "react-icons/md";
import {
  FiFileText,
  FiAlertCircle,
  FiChevronUp,
  FiChevronDown,
  FiMaximize2,
  FiInfo
} from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";

const TabellaAnomalie = () => {
  const [loading, setLoading] = useState(true);
  const [totaleAlert, setTotaleAlert] = useState(0);

  const [riepilogoFornitori, setRiepilogoFornitori] = useState([]);
  const [allLM, setAllLM] = useState([]);

  // Stato per il widget a tutto schermo
  const [showFullscreenModal, setShowFullscreenModal] = useState(false);

  // Stati per l'ordinamento delle colonne
  const [sortConfig, setSortConfig] = useState({
    key: "totaleAnomalie",
    direction: "desc",
  });

  // Stati per i Modali di dettaglio
  const [showAnomalieModal, setShowAnomalieModal] = useState(false);
  const [selectedAnomalieRows, setSelectedAnomalieRows] = useState([]);
  const [selectedFornitoreNome, setSelectedFornitoreNome] = useState("");
  const [causaleSelezionata, setCausaleSelezionata] = useState("");

  const [showLmModal, setShowLmModal] = useState(false);
  const [selectedLmRows, setSelectedLmRows] = useState([]);

  useEffect(() => {
    fetch("ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const arrayAnomalie = (data?.ANOMALIE || []).flat();
        const arrayLM = (data?.LM || []).flat();

        setTotaleAlert(arrayAnomalie.length);
        setAllLM(arrayLM);

        const fornitoriSet = new Set([
          ...arrayAnomalie.map(
            (a) => a.ragione_sociale || "FORNITORE NON SPECIFICATO",
          ),
          ...arrayLM.map(
            (lm) => lm["Ragione Sociale"] || "FORNITORE NON SPECIFICATO",
          ),
        ]);

        const righeFornitori = Array.from(fornitoriSet).map((fornitore) => {
          const anomalieFornitore = arrayAnomalie.filter(
            (a) =>
              (a.ragione_sociale || "FORNITORE NON SPECIFICATO") === fornitore,
          );
          const lmFornitore = arrayLM.filter(
            (lm) =>
              (lm["Ragione Sociale"] || "FORNITORE NON SPECIFICATO") ===
              fornitore,
          );

          const conteggioCausali = {};
          anomalieFornitore.forEach((ant) => {
            const causale = ant.causale || "Altro";
            conteggioCausali[causale] = (conteggioCausali[causale] || 0) + 1;
          });

          return {
            nome: fornitore,
            totaleAnomalie: anomalieFornitore.length,
            dettaglioAnomalie: anomalieFornitore,
            conteggioCausali: conteggioCausali,
            totaleLM: lmFornitore.length,
            dettaglioLM: lmFornitore,
          };
        });

        // Ordinamento iniziale: prima chi ha anomalie
        righeFornitori.sort((a, b) => {
          if (b.totaleAnomalie !== a.totaleAnomalie) {
            return b.totaleAnomalie - a.totaleAnomalie;
          }
          return b.totaleLM - a.totaleLM;
        });

        setRiepilogoFornitori(righeFornitori);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch:", err);
        setLoading(false);
      });
  }, []);

  const requestSort = (key) => {
    let direction = "desc";
    if (sortConfig.key === key && sortConfig.direction === "desc") {
      direction = "asc";
    }
    setSortConfig({ key, direction });
  };

  const getSortedFornitori = () => {
    const sortedItems = [...riepilogoFornitori];
    if (sortConfig !== null) {
      sortedItems.sort((a, b) => {
        let valA = a[sortConfig.key];
        let valB = b[sortConfig.key];

        if (typeof valA === "string") {
          return sortConfig.direction === "asc"
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
        }

        return sortConfig.direction === "asc" ? valA - valB : valB - valA;
      });
    }
    return sortedItems;
  };

  const renderTooltipSpiegazione = (props) => (
    <Tooltip
      id="info-rimessi-tooltip"
      {...props}
      style={{ ...props.style, fontSize: "0.85rem" }}
    >
Questo pannello mostra le anomalie BEM non risolte e le LM aperte associate ai fornitori, raggruppando automaticamente i dati per ragione sociale.
È possibile ordinare la tabella e aprire il dettaglio completo di anomalie e documenti cliccando sulle righe o sulle causali visualizzate.
    </Tooltip>
  );

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key)
      return (
        <span className="ms-1 text-muted" style={{ opacity: 0.4 }}>
          <FiChevronDown size={10} />
        </span>
      );
    return sortConfig.direction === "asc" ? (
      <FiChevronUp className="ms-1 text-dark" size={12} />
    ) : (
      <FiChevronDown className="ms-1 text-dark" size={12} />
    );
  };

  const formatData = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "-";
    const soloData = dateStr.split(" ")[0];
    return soloData.split("-").reverse().join("/");
  };

  const formatNumero = (valore, decimali = 2) => {
    if (!valore) return "-";
    const num = parseFloat(valore);
    return isNaN(num) ? "-" : num.toFixed(decimali);
  };

  const handleCausaleClick = (e, fornitore, causale) => {
    e.stopPropagation();
    const righeFiltrate = fornitore.dettaglioAnomalie.filter(
      (a) => (a.causale || "Altro") === causale,
    );

    setSelectedFornitoreNome(fornitore.nome);
    setCausaleSelezionata(causale);
    setSelectedAnomalieRows(righeFiltrate);
    setShowAnomalieModal(true);
  };

  const handleFornitoreClick = (fornitore) => {
    if (fornitore.totaleAnomalie === 0) return;
    setSelectedFornitoreNome(fornitore.nome);
    setCausaleSelezionata("TUTTE");
    setSelectedAnomalieRows(fornitore.dettaglioAnomalie);
    setShowAnomalieModal(true);
  };

  const apriModaleLM = (e, fornitore) => {
    e.stopPropagation();
    setSelectedFornitoreNome(fornitore.nome);
    setSelectedLmRows(fornitore.dettaglioLM);
    setShowLmModal(true);
  };

  // Rendering della sola tabella (estratta per usarla sia nella Card che nel Modale Fullscreen)
  const renderTabellaContenuto = () => (
    <Table hover className="table-clean border-0">
      <thead>
        <tr>
          <th style={{ width: "38%" }} onClick={() => requestSort("nome")}>
            Fornitore {renderSortIcon("nome")}
          </th>
          <th
            style={{ width: "44%" }}
            onClick={() => requestSort("totaleAnomalie")}
          >
            Causali {renderSortIcon("totaleAnomalie")}
          </th>
          <th
            style={{ width: "18%" }}
            className="text-center"
            onClick={() => requestSort("totaleLM")}
          >
            LM Aperte {renderSortIcon("totaleLM")}
          </th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan="3" className="text-center py-5 text-muted small">
              Aggregazione dati in corso...
            </td>
          </tr>
        ) : riepilogoFornitori.length === 0 ? (
          <tr>
            <td colSpan="3" className="text-center py-5 text-muted small">
              Nessun dato registrato oggi.
            </td>
          </tr>
        ) : (
          getSortedFornitori().map((fornitore, idx) => (
            <tr
              key={idx}
              className="row-clean"
              onClick={() => handleFornitoreClick(fornitore)}
            >
              <td
                className="fw-semibold text-dark text-truncate"
                title="Clicca per vedere tutto"
              >
                {fornitore.nome}
              </td>
              <td>
                {fornitore.totaleAnomalie === 0 ? (
                  <span
                    className="text-muted"
                    style={{ fontStyle: "italic", fontSize: "0.7rem" }}
                  >
                    Nessuna
                  </span>
                ) : (
                  <div className="d-flex align-items-center text-truncate fw-bold">
                    <FiAlertCircle
                      size={12}
                      className="flex-shrink-0 text-danger me-2"
                    />
                    <span className="text-truncate fw-bold">
                      {Object.entries(fornitore.conteggioCausali).map(
                        ([causale, qta], cIdx, arr) => (
                          <span key={cIdx}>
                            <span
                              className="testo-causale fw-bold"
                              onClick={(e) =>
                                handleCausaleClick(e, fornitore, causale)
                              }
                              title={`Mostra solo anomalie per ${causale}`}
                            >
                              {causale} ({qta})
                            </span>
                            {cIdx < arr.length - 1 && (
                              <span className="separatore-causale">•</span>
                            )}
                          </span>
                        ),
                      )}
                    </span>
                  </div>
                )}
              </td>
              <td className="text-center">
                {fornitore.totaleLM > 0 ? (
                  <span
                    className="link-lm d-inline-flex align-items-center gap-1"
                    onClick={(e) => apriModaleLM(e, fornitore)}
                  >
                    <FiFileText size={12} /> LM APERTE - {fornitore.totaleLM}
                  </span>
                ) : (
                  <span className="text-muted" style={{ fontStyle: "italic" }}>
                    -
                  </span>
                )}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );

  return (
    <>
      {/* CARD STANDARD WIDGET */}
      <div
        className="shadow-sm card"
        style={{
          borderRadius: "14px",
          border: "1px solid #e2e8f0",
          height: "380px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          backgroundColor: "#fff",
        }}
      >
        {/* Header Widget - Icona Info affiancata al titolo */}
        <div className="p-3 bg-white border-bottom d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-2">
            <span
              onClick={() => setShowFullscreenModal(true)}
              style={{
                fontWeight: "800",
                fontSize: "0.72rem",
                color: "#0f172a",
                letterSpacing: "0.5px",
                cursor: "pointer",
              }}
              className="d-inline-flex align-items-center gap-1 titolo-header"
              title="Espandi a tutto schermo"
            >
              ANOMALIE BEM (NON RISOLTE)
            </span>
            <OverlayTrigger placement="bottom" overlay={renderTooltipSpiegazione}>
              <span style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}>
                <FiInfo size={14} color="#adb5bd" />
              </span>
            </OverlayTrigger>
          </div>

          <span
            className="text-danger fw-bold d-flex align-items-center gap-1"
            style={{ fontSize: "0.68rem" }}
          >
            <MdWarningAmber size={14} /> {totaleAlert} ANOMALIE ATTIVE
          </span>
        </div>

        <style>{`
          .titolo-header:hover .split-icon { color: #0284c7 !important; }
          .scroll-area { overflow-y: auto; overflow-x: hidden; flex-grow: 1; background: #fff; }
          .table-clean { margin-bottom: 0; table-layout: fixed; width: 100%; border-collapse: separate; border-spacing: 0; }
          
          .table-clean thead th { 
            position: sticky; top: 0; z-index: 20; 
            background-color: #fff !important; color: #94a3b8 !important; 
            font-size: 0.65rem; text-transform: uppercase; padding: 12px;
            border-bottom: 1px solid #f1f5f9 !important;
            font-weight: 600; letter-spacing: 0.3px;
            cursor: pointer;
            user-select: none;
          }
          .table-clean thead th:hover {
            color: #475569 !important;
            background-color: #f8fafc !important;
          }
          
          .table-clean tbody td { 
            font-size: 0.75rem; padding: 12px; 
            vertical-align: middle; border-bottom: 1px solid #f8fafc;
            white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
          }
          
          .row-clean { transition: background 0.12s ease; cursor: pointer; }
          .row-clean:hover { background-color: #f8fafc !important; }
          
          .testo-causale { color: #ef4444; font-weight: 500; transition: color 0.15s; }
          .testo-causale:hover { color: #b91c1c; text-decoration: underline; }
          .separatore-causale { color: #cbd5e1; margin: 0 6px; font-weight: 300; }
          
          .link-lm { color: #0284c7; font-weight: 600; cursor: pointer; text-decoration: none; padding: 4px 8px; border-radius: 4px; transition: background 0.15s; }
          .link-lm:hover { color: #0369a1; background-color: #f0f9ff; text-decoration: underline; }
          
          /* Stili specifici per la modalità a schermo intero */
          .modal-fullscreen-custom .table-clean tbody td {
            font-size: 0.85rem;
            padding: 16px 12px;
          }
          .modal-fullscreen-custom .table-clean thead th {
            font-size: 0.75rem;
            padding: 16px 12px;
          }
        `}</style>

        {/* Corpo della Tabella nella Card */}
        <div className="scroll-area p-0">{renderTabellaContenuto()}</div>
      </div>

      {/* MODALE DI GRANDE CORPO: COMPONENTE A TUTTO SCHERMO */}
      <Modal
        show={showFullscreenModal}
        onHide={() => setShowFullscreenModal(false)}
        fullscreen={true}
        className="modal-fullscreen-custom"
      >
        <Modal.Header className="px-4 py-3 bg-white border-bottom d-flex align-items-center justify-content-between">
          <Modal.Title
            className="d-flex align-items-center gap-2"
            style={{ fontSize: "1rem", fontWeight: "800", color: "#0f172a" }}
          >
            ANOMALIE BEM — VISTA COMPLETA
            <OverlayTrigger placement="bottom" overlay={renderTooltipSpiegazione}>
              <span style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}>
                <FiInfo size={16} color="#adb5bd" />
              </span>
            </OverlayTrigger>
            <span
              className="badge bg-danger-subtle text-danger border border-danger-subtle ms-2"
              style={{ fontSize: "0.7rem", padding: "5px 10px" }}
            >
              {totaleAlert} ANOMALIE
            </span>
          </Modal.Title>
          <Button
            variant="outline-secondary"
            size="sm"
            className="d-flex align-items-center gap-1 border-0"
            onClick={() => setShowFullscreenModal(false)}
            style={{ fontSize: "0.8rem", fontWeight: "600" }}
          >
            <MdFullscreenExit size={18} /> Chiudi Schermo Intero
          </Button>
        </Modal.Header>
        <Modal.Body className="p-0 scroll-area">
          {renderTabellaContenuto()}
        </Modal.Body>
      </Modal>

      {/* MODALE 1: DETTAGLIO ANOMALIE FILTRATE */}
      <Modal
        show={showAnomalieModal}
        onHide={() => setShowAnomalieModal(false)}
        size="lg"
        centered
        className="p-5"
      >
        <Modal.Header closeButton className="border-bottom-0 pt-3 pb-2 px-3">
          <Modal.Title
            style={{ fontSize: "0.85rem", fontWeight: "800", color: "#0f172a" }}
          >
            ANOMALIE — {selectedFornitoreNome}{" "}
            {causaleSelezionata !== "TUTTE" && `(${causaleSelezionata})`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="p-0"
          style={{ maxHeight: "400px", overflowY: "auto" }}
        >
          <Table responsive hover className="align-middle m-0 table-clean">
            <thead>
              <tr>
                <th>Causale</th>
                <th>Articolo</th>
                <th>Num. Rimesso</th>
                <th>Data Rimesso</th>
                <th>Compl. BEM</th>
              </tr>
            </thead>
            <tbody>
              {selectedAnomalieRows.map((item, rIdx) => (
                <tr key={rIdx}>
                  <td className="fw-semibold text-danger">
                    {item.causale || "-"}
                  </td>
                  <td className="fw-bold text-dark">{item.articolo || "-"}</td>
                  <td className="font-monospace text-secondary">
                    {item.numero_rimesso?.replace(/,$/, "") || "-"}
                  </td>
                  <td>{formatData(item.data_rimesso)}</td>
                  <td
                    className={
                      item.data_completamento_bem
                        ? "text-success fw-medium"
                        : "text-muted"
                    }
                  >
                    {item.data_completamento_bem
                      ? formatData(item.data_completamento_bem)
                      : "In attesa"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="border-top-0 p-2">
          <Button
            variant="link"
            size="sm"
            className="text-secondary text-decoration-none"
            onClick={() => setShowAnomalieModal(false)}
          >
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>

      {/* MODALE 2: DETTAGLIO DOCUMENTI LM */}
      <Modal
        show={showLmModal}
        onHide={() => setShowLmModal(false)}
        size="xl"
        centered
        className="p-5"
      >
        <Modal.Header closeButton className="border-bottom-0 pt-3 pb-2 px-3">
          <Modal.Title
            style={{ fontSize: "0.85rem", fontWeight: "800", color: "#0f172a" }}
          >
            REGISTRO DOCUMENTI LM — {selectedFornitoreNome}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="p-0"
          style={{ maxHeight: "450px", overflowY: "auto" }}
        >
          <Table responsive hover className="align-middle m-0 table-clean">
            <thead>
              <tr>
                <th>Dep</th>
                <th>Tipo Doc</th>
                <th>Num Doc</th>
                <th>Data Doc</th>
                <th>Precodice</th>
                <th>Articolo</th>
                <th>Descrizione</th>
                <th className="text-center">Qta</th>
                <th>Netto (€)</th>
                <th>Importo (€)</th>
                <th>Note Lista / Dettagli Reso</th>
              </tr>
            </thead>
            <tbody>
              {selectedLmRows.map((lm, index) => (
                <tr key={index}>
                  <td className="text-start">{lm["Deposito"] || "-"}</td>
                  <td className="fw-semibold text-info">
                    {lm["Tipo Doc"] || "LM"}
                  </td>
                  <td className="fw-semibold">{lm["Num Doc"] || "-"}</td>
                  <td>{formatData(lm["Data Doc"])}</td>
                  <td>{lm["Precodice"] || "-"}</td>
                  <td className="fw-bold text-primary">
                    {lm["Articolo"] || "-"}
                  </td>
                  <td
                    className="text-truncate"
                    style={{ maxWidth: "150px" }}
                    title={lm["Descrizione"]}
                  >
                    {lm["Descrizione"] || "-"}
                  </td>
                  <td className="fw-bold text-center">
                    {formatNumero(lm["Qta"], 0)}
                  </td>
                  <td>{formatNumero(lm["Netto"], 2)}</td>
                  <td className="fw-bold">{formatNumero(lm["Importo"], 2)}</td>
                  <td
                    className="text-muted small"
                    style={{ maxWidth: "220px", whiteSpace: "normal" }}
                  >
                    {lm["Note Lista"] || lm["Note Doc"] || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="border-top-0 p-2">
          <Button
            variant="link"
            size="sm"
            className="text-secondary text-decoration-none"
            onClick={() => setShowLmModal(false)}
          >
            Chiudi Registro
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TabellaAnomalie;